const request = async ( data, isJson = false, action = false, nonce = false ) => {
	// Remove the ajax input to prevent Gravity Forms ajax submission handler from handling the submission in the backend.
	data.delete( 'gform_ajax' );
	const options = {
		method: 'POST',
		credentials: 'same-origin',
		body: data,
	};

	if ( isJson ) {
		options.headers = { 'Accept': 'application/json', 'content-type': 'application/json' }
	}

	const url = new URL( gforms_stripe_frontend_strings.ajaxurl )

	if ( action ) {
		url.searchParams.set( 'action', action )
	}

	if ( nonce ) {
		url.searchParams.set( 'nonce', nonce )
	}

	console.log( url.toString() );
	return await fetch(
		url.toString(),
		options
	).then(
		response => response.json()
	);
}

export default request;
